import { createAction, props } from '@ngrx/store';
import {
  AlertUpdatePayload,
  MaintenanceAlert,
  MaintenanceSchedule,
} from '@fc-core';

export const loadMaintenanceSchedules = createAction(
  '[MaintenanceSchedule] Load MaintenanceSchedules',
  props<{ vehicleId: number }>(),
);
export const loadMaintenanceSchedulesSuccess = createAction(
  '[MaintenanceSchedule] Load MaintenanceSchedules Success',
  props<{ schedules: MaintenanceSchedule[] }>(),
);

export const cleanTooltipInfo = createAction(
  '[MaintenanceSchedule] Clean popup info',
);
export const loadTooltipMaintenanceSchedules = createAction(
  '[MaintenanceSchedule] Load tooltip MaintenanceSchedules',
  props<{ vehicleId: number }>(),
);
export const loadTooltipMaintenanceSchedulesSuccess = createAction(
  '[MaintenanceSchedule] Load tooltip MaintenanceSchedules Success',
  props<{ schedules: MaintenanceSchedule[] }>(),
);
export const addMaintenanceSchedule = createAction(
  '[MaintenanceSchedule] Add MaintenanceSchedules',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const addMaintenanceScheduleSuccess = createAction(
  '[MaintenanceSchedule] Add MaintenanceSchedules Success',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const deleteMaintenanceSchedule = createAction(
  '[MaintenanceSchedule] Delete MaintenanceSchedules',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const deleteMaintenanceScheduleSuccess = createAction(
  '[MaintenanceSchedule] Delete MaintenanceSchedules Success',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const updateMaintenanceSchedule = createAction(
  '[MaintenanceSchedule] Update MaintenanceSchedule',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const updateMaintenanceScheduleSuccess = createAction(
  '[MaintenanceSchedule] Update MaintenanceSchedule Success',
  props<{ maintenanceSchedule: MaintenanceSchedule }>(),
);
export const closeMaintenanceSchedule = createAction(
  '[MaintenanceSchedule] Close MaintenanceSchedule',
  props<{
    attachments: File[];
    schedule: MaintenanceSchedule;
    alert: MaintenanceAlert;
    closePayload: any;
  }>(),
);
export const closeMaintenanceScheduleSuccess = createAction(
  '[MaintenanceSchedule] Close MaintenanceSchedule Success',
);
export const maintenanceSchedulesError = createAction(
  '[MaintenanceSchedule] MaintenanceSchedules Error',
  props<{ err: any }>(),
);

export const loadAllMaintenanceScheduleAlerts = createAction(
  '[MaintenanceSchedule] Load All Maintenance Schedule Alerts',
  props<{ schedule: MaintenanceSchedule; options: { [key: string]: any } }>(),
);

export const loadAllMaintenanceScheduleAlertsSuccess = createAction(
  '[MaintenanceSchedule] Load All Maintenance Schedule Alerts Success',
  props<{ alertList: MaintenanceAlert[] }>(),
);
export const updateMaintenanceScheduleAlert = createAction(
  '[MaintenanceSchedule] Update Maintenance Schedule Alerts',
  props<{ payload: AlertUpdatePayload }>(),
);

export const updateMaintenanceScheduleAlertSuccess = createAction(
  '[MaintenanceSchedule] Update Maintenance Schedule Alerts Success',
  props<{ updatedAlert: MaintenanceAlert }>(),
);
